import type { NodeDefault } from '../../types';
import { BlockEnum } from '../../types';
import {
  // ALL_CHAT_AVAILABLE_BLOCKS,
  ALL_COMPLETION_AVAILABLE_BLOCKS,
} from '../../blocks';
import type { NestedFlowNodeType } from './types';

const nodeDefault: NodeDefault<NestedFlowNodeType> = {
  defaultValue: {
    detail: {
      desc: '',
      nestedFlowInfo: {
        id: '',
        name: '',
      },
    }
  },
  getAvailablePrevNodes() {
    return ALL_COMPLETION_AVAILABLE_BLOCKS.filter(
      (type) => type !== BlockEnum.End && type !== BlockEnum.Mirror,
    );
  },
  getAvailableNextNodes(isChatMode: boolean = false) {
    return ALL_COMPLETION_AVAILABLE_BLOCKS;
  },
  checkValid() {
    return {
      isValid: true,
    };
  },
};

export default nodeDefault;
